import { tns } from "tiny-slider/src/tiny-slider"

window.tns = tns;


